import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

import {
  PhoneNumberInput,
  PhoneNumberInputProps,
} from '../../atoms/Form/PhoneNumberInput/PhoneNumberInput';

interface PhoneNumberInputHookFormProps extends PhoneNumberInputProps {
  control: Control<any>;
}

export const PhoneNumberInputHookForm: FC<PhoneNumberInputHookFormProps> = ({
  control,
  name = '',
  onChange,
  ...rest
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <PhoneNumberInput
            {...rest}
            name={field.name}
            onChange={(newValue, meta) => {
              field.onChange(newValue);

              if (onChange) {
                onChange(newValue, meta);
              }
            }}
            value={field.value}
          />
        );
      }}
    />
  );
};
